export var EAuthMode = /*#__PURE__*/function (EAuthMode) {
  EAuthMode["Default"] = "default";
  EAuthMode["OneTap"] = "onetap";
  return EAuthMode;
}({});
export var EAuthStatus = /*#__PURE__*/function (EAuthStatus) {
  EAuthStatus["Connected"] = "connected";
  EAuthStatus["NotAuthorized"] = "not_authorized";
  EAuthStatus["Unknown"] = "unknown";
  return EAuthStatus;
}({});

/**
 * Mail.Ru OAuth API
 */